/**
 * Asynchronously loads the component for PricingPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./PricingPage'));
